module.exports = __webpack_public_path__ + "img/consultoria_4-3_1024.2a319345.jpg";